import { render, staticRenderFns } from "./ContactWithoutCalling.vue?vue&type=template&id=52338ac3&scoped=true&"
import script from "./ContactWithoutCalling.vue?vue&type=script&lang=js&"
export * from "./ContactWithoutCalling.vue?vue&type=script&lang=js&"
import style0 from "./ContactWithoutCalling.vue?vue&type=style&index=0&id=52338ac3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52338ac3",
  null
  
)

export default component.exports